import {createContext} from 'react';

import Store from './store';

export {default as Store} from './store';
export const StoreContext = createContext<Store>(null!);
